/* eslint-disable */
import React from "react";
import themePropTypes from "../theme-prop-types";

const HorizontalGraphLines = ({ top, times, canShow }) => {
  return (
    <div className='graph-vertical-lines-web-sdk'>
      {canShow
        ? times?.map((time, index) => {
            return (
              <div
                className='graph-vertical-line-web-sdk'
                style={{ marginTop: `${index == 0 ? 0 : top + 19}px` }}
                key={index}
              ></div>
            );
          })
        : null}
    </div>
  );
};

HorizontalGraphLines.propTypes = themePropTypes.graph;
export default HorizontalGraphLines;
